<script>
import { fileHelper } from "@/helpers/index";
import VueEasyLightbox from "vue-easy-lightbox";
import ModalFrame from "@/components/modals/ModalFrame.vue";

export default {
    name: "AppMultipleImageUpload",

    components: {
        VueEasyLightbox,
        ModalFrame,
    },

    data() {
        return {
            showLightbox: false,
            showPreview: false,
            tempLink: null,
        };
    },

    props: {
        items: { type: Array, default: () => [] },
    },

    computed: {
        // fileType() {
        //     return fileHelper.getFileType(this.fileExtension);
        // },
    },
    methods: {
        getFileType(fileExtension) {
            return fileHelper.getFileType(fileExtension);
        },
    },
};
</script>

<template>
    <div>
        <h5 v-if="!items.length" class="text-gray-darker font-size-14">N/A</h5>
        <div v-else class="document-preview me-auto d-flex flex-wrap">
            <div v-for="(item, key) in items" :key="key" class="cursor-pointer">
                <!-- {{ item }} -->
                <!-- Document Preview -->
                <div
                    v-if="
                        item.fileLink &&
                        getFileType(item.fileExtension) === 'document'
                    "
                >
                    <div
                        @click="
                            tempLink = item.fileLink;
                            showPreview = true;
                        "
                    >
                        <div
                            class="pe-none position-relative overflow-hidden d-flex justify-content-center p-2"
                        >
                            <embed
                                :src="`${item.fileLink}#toolbar=0`"
                                height="400px"
                                type="application/pdf"
                                style="overflow: hidden !important"
                            />
                            <div
                                class="document-mask text-primary d-flex justify-content-center align-items-center"
                            >
                                <span class="border-bottom border-primary"
                                    >Preview</span
                                >
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Image Preview -->
                <div
                    v-else-if="
                        item.fileLink &&
                        getFileType(item.fileExtension) === 'image'
                    "
                >
                    <div
                        @click="
                            tempLink = item.fileLink;
                            showLightbox = true;
                        "
                    >
                        <div class="img position-relative p-2">
                            <img
                                :src="item.fileLink"
                                class="object-contain"
                                width="100%"
                                height="400px"
                            />
                            <div
                                class="document-mask text-primary d-flex justify-content-center align-items-center"
                            >
                                <span class="border-bottom border-primary"
                                    >Preview</span
                                >
                            </div>
                        </div>
                    </div>
                    <vue-easy-lightbox
                        :visible="showLightbox"
                        :imgs="tempLink"
                        @hide="
                            showLightbox = false;
                            tempLink = null;
                        "
                    ></vue-easy-lightbox>
                </div>
            </div>
        </div>

        <ModalFrame
            v-if="showPreview"
            :link="tempLink"
            @close="
                showPreview = false;
                tempLink = null;
            "
        ></ModalFrame>
    </div>
</template>

<style lang="scss" scoped>
.document-preview {
    .document-mask {
        opacity: 0;
        transition: 0.3s;
    }
}
.img {
    &:hover {
        .document-mask {
            opacity: 1;
            transition: 0.3s;
        }
    }
}
.document {
    &-preview {
        border: 2px dashed #ced4da;
        border-radius: 5px;
        padding: 20px;
    }
    &-mask {
        background-color: #e5e5e5;
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 5px;
    }
}
.img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.d-flex.flex-wrap {
    gap: 20px;
}
</style>
